import { Dialog } from '@progress/kendo-react-dialogs';
import React, { useEffect, useRef, useState } from 'react';
import { HubConnection } from '@microsoft/signalr';
import { AsiteDocumentsSyncClientLogDto } from '../../../../../swagger';
import useRelaticsDownloadXml from '../../RelaticsSyncLogs/useRelaticsDownloadXml';
import { TypeOfXMLFile } from '../RelaticsDocumentsDialog';
import useRelaticsRealTimeLogDialog from './useRelaticsRealTimeLogDialog';
import useStyles from './RelaticsRealTimeLogDialogComponent.styles';
interface RelaticsRealTimeLogDialogComponentProps {
    displayLogJobRunning: boolean | undefined,
    setDisplayLogJobRunning: React.Dispatch<React.SetStateAction<boolean>>,
    data: AsiteDocumentsSyncClientLogDto[],
    setData: React.Dispatch<React.SetStateAction<AsiteDocumentsSyncClientLogDto[]>>,
    connection: HubConnection | undefined,
    dataMessgaes: any,

}

const RelaticsRealTimeLogDialogComponent: React.FC<RelaticsRealTimeLogDialogComponentProps> = ({ displayLogJobRunning, setDisplayLogJobRunning, data, setData, connection, dataMessgaes }) => {
    const classes = useStyles();
    const { query } = useRelaticsRealTimeLogDialog(data, setData);

    const { handleDownloadDocument } = useRelaticsDownloadXml();

    const messagesEndRef: any = useRef(null)
    const scrollToBottom = () => {
        messagesEndRef.current?.scrollIntoView({ behavior: "smooth" })
    }

    const eventReceiveMessage = (connection: HubConnection) => {
        connection.off('AsiteRelaticsSyncEvent');
        connection.on('AsiteRelaticsSyncEvent', (message: any) => {
            const updatedMessages = [...dataMessgaes.current];
            updatedMessages.push(message.model);
            setData(updatedMessages);
        });
    };
    useEffect(() => {
        if (query.isSuccess) {
            if (connection) {
                if (connection?.state === 'Disconnected') {
                    connection.start()
                        .then(result => {
                            eventReceiveMessage(connection);
                        })
                        .catch(e => console.error('Connection failed: ', e));
                }
                else {
                    eventReceiveMessage(connection);
                }
            }

        }

    }, [connection, query.isSuccess]);


    useEffect(() => {
        if (displayLogJobRunning) {
            query.refetch();
        }
    }, [displayLogJobRunning]);

    useEffect(() => {
        scrollToBottom()
    }, [data]);


    return (
        <div>

            <Dialog
                title={'Real time log sync'}
                onClose={() => {
                    setDisplayLogJobRunning(false);
                }}
                width={'80vw'}
                autoFocus={true}
            >
                <div className={classes.root}>

                    {data

                        .map((itemData) => {
                            let messageHtml: any = (<div></div>);

                            if (itemData.simpleMessage) {
                                messageHtml = (
                                    <p className={classes.simpleMessage}> {itemData.date} Message: {itemData.simpleMessage}</p>
                                )
                            }
                            if (itemData?.relaticsDocumentsSyncLogId || 0 > 0) {
                                messageHtml = (
                                    <p className={classes.simpleMessage}> {itemData.date} Message: {itemData.simpleMessage}
                                        <span>    </span>
                                        <a
                                            onClick={(e) => {
                                                handleDownloadDocument({ ...itemData, id: itemData.relaticsDocumentsSyncLogId }, TypeOfXMLFile.Send)
                                            }}
                                            href={'javascript:void(0)'}>{itemData.fileNameDocumentSend}
                                        </a>

                                        <span>    </span>
                                        <a
                                            onClick={(e) => {
                                                handleDownloadDocument({ ...itemData, id: itemData.relaticsDocumentsSyncLogId }, TypeOfXMLFile.Reponse)
                                            }}
                                            href={'javascript:void(0)'}>  {itemData.fileNameDocumentResponse}</a></p>
                                )
                            }
                            return messageHtml;
                        })}
                    <div ref={messagesEndRef} />
                    {!query.isFetching && data.length === 0 ? (<p>No data</p>) : (<></>)}
                    {query.isFetching && <p>Loading...</p>}


                </div>

            </Dialog>

        </div>
    );

};


export default RelaticsRealTimeLogDialogComponent;


